import {
  StorefrontLinkGetRequestType,
  StorefrontLinkGetResponseType,
} from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

/** The link lookup is public because buyers use it before signing up. */
export const getStorefrontLinkQueryOptions = <
  TData = StorefrontLinkGetResponseType,
>(
  options?: ApiV2QueryOptions<TData>,
) =>
  getDefaultQueryOptionsV2({
    user: undefined,
    business: null,
    overrideOptions: {
      ...options,
      requireUser: false,
      requireBusiness: false,
    },
  });

export const useStorefrontLink = <TData = StorefrontLinkGetResponseType,>(
  storefrontLinkPassword: string | null,
  params: StorefrontLinkGetRequestType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [user?.uid, business?.id, ServerStateKeys.StorefrontLink, params],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `storefront-link/${storefrontLinkPassword}`,
        params,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getStorefrontLinkQueryOptions(options),
  });
};
